import { render, staticRenderFns } from "./KeyboardR6.vue?vue&type=template&id=0bc10399&scoped=true&"
import script from "./KeyboardR6.vue?vue&type=script&lang=js&"
export * from "./KeyboardR6.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardR6.vue?vue&type=style&index=0&id=0bc10399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc10399",
  null
  
)

export default component.exports